import React from 'react';

var Cancel = function Cancel(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.487 12l5.205 5.205a1.052 1.052 0 0 1-1.487 1.487L12 13.487l-5.205 5.205a1.052 1.052 0 0 1-1.487-1.487L10.513 12 5.308 6.795a1.052 1.052 0 0 1 1.487-1.487L12 10.513l5.205-5.205a1.052 1.052 0 0 1 1.487 1.487L13.487 12z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Cancel.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Cancel as icon };
export default iconHandler(Cancel);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Cancel.js
// module id = 589
// module chunks = 0